import React, { useState } from 'react';
import { graphql } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import TermsModal from './TermsModal';

const ModularPrizeDrawForm = ({ data }) => {
  const [title, setTitle] = useState();

  const { formHeading, legalTermsContent, slug } = data;

  const titleOptions = [
    'Please select',
    'Mr',
    'Mrs',
    'Miss',
    'Ms',
    'Mx',
    'Other',
  ];
  return (
    <div className="form-container">
      <div className="form-heading">
        <LitStructuredText data={formHeading} basic />
      </div>
      <div className="form-wrapper">
        <form
          data-netlify="true"
          method="post"
          data-netlify-honeypot="bot-field"
          name={`${slug}`}
          action="/prize-draw-success"
          className="form"
        >
          <input type="hidden" name="form-name" value={`${slug}`} />

          <div className="form-input-container">
            <div className="form-input-inner column-1">
              <label htmlFor="name">Title*</label>
              <div className="form-select-arrow">
                <select
                  type="text"
                  name="Title"
                  required
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                >
                  {titleOptions.map((title) => (
                    <option
                      key={title}
                      value={title === 'Please select' ? '' : title}
                    >
                      {title}
                    </option>
                  ))}
                </select>
              </div>
              {title === 'Other' && (
                <div className="form-input-inner column-1">
                  <label htmlFor="CustomTitle">
                    Custom title<i>*</i>
                  </label>
                  <input
                    required
                    type="text"
                    name="Custom Title"
                    defaultValue={title}
                  />{' '}
                </div>
              )}
            </div>
            <div className="form-input-inner column-3">
              <label htmlFor="name">Full name*</label>
              <input
                type="text"
                name="Name"
                required
                placeholder="Enter your name"
              />
            </div>
            <div className="form-input-inner column-1">
              <label htmlFor="email">Email*</label>
              <input
                type="email"
                name="Email"
                required
                pattern="^.+@.+\.[a-zA-Z]{2,63}$"
                maxLength="250"
                placeholder="Enter your email"
              />
            </div>
            <div className="form-input-inner column-3">
              <label htmlFor="ContactNumber">Telephone*</label>
              <input
                type="text"
                name="ContactNumber"
                required
                placeholder="Enter your telephone"
              />
            </div>
            <div className="form-input-inner column-1">
              <label htmlFor="HouseNumber">House number*</label>
              <input
                type="text"
                required
                name="HouseNumber"
                placeholder="Enter your House number"
              />
            </div>
            <div className="form-input-inner column-3">
              <label htmlFor="Postcode">Your postcode*</label>
              <input
                type="text"
                required
                name="Postcode"
                placeholder="Enter your postcode"
              />
            </div>
            <div className="form-input-inner column-1">
              <label htmlFor="CurrentProvider">Current Internet Provider</label>
              <input
                type="text"
                name="CurrentProvider"
                placeholder="Enter your Current Internet Provider"
              />
            </div>
            <div className="form-input-inner column-3">
              <label htmlFor="ContractEndDate">Contract End Date</label>
              <input type="date" name="ContractEndDate" />
            </div>
            <div className="form-input-inner">
              <label htmlFor="ContactPreference">Contact Preference</label>
              <div className="form-select-arrow">
                <select type="text" name="ContactPreference">
                  <option name="Phone">Phone</option>
                  <option name="Email">Email</option>
                </select>
              </div>
            </div>{' '}
          </div>

          {legalTermsContent.map(
            ({ terms, termText, termsSecondaryText, linkText }, index) => {
              return (
                <div className="form-checkbox-container" key={index}>
                  <TermsModal
                    terms={terms}
                    termsText={termText}
                    termsSecondaryText={termsSecondaryText}
                    linkText={linkText}
                  />
                </div>
              );
            },
          )}
          <div className="form-single-button-container">
            <button type="submit" className="button-blue">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModularPrizeDrawForm;

export const fragment = graphql`
  fragment ModularPrizeDrawForm on DatoCmsQuizForm {
    internal {
      type
    }
    slug
    formHeading {
      value
    }
    legalTermsContent {
      linkText
      termText
      termsSecondaryText
      terms {
        slug
        title
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  }
`;
